import { reactive } from "@vue/reactivity";
import useValidators from '@/modules/Validators'
const errors = reactive({});
export default function useFormValidation() {
    const { isEmpty, minLength, isEmail ,isTheSame} = useValidators();
    const validateFirstNameField = (fieldName, fieldValue) => {
        errors[fieldName] = !fieldValue ? isEmpty(fieldName, fieldValue) : minLength(fieldName, fieldValue, 4)
    }
    const validateLastNameField = (fieldName, fieldValue) => {
        errors[fieldName] = !fieldValue ? isEmpty(fieldName, fieldValue) : minLength(fieldName, fieldValue, 4)
    }
    const validateEmailField = (fieldName, fieldValue) => {
        errors[fieldName] = !fieldValue ? isEmpty(fieldName, fieldValue) : isEmail(fieldName, fieldValue)
    }
    const validatePasswordField = (fieldName, fieldValue) => { 
        errors[fieldName] = !fieldValue ? isEmpty(fieldName, fieldValue) : minLength(fieldName, fieldValue,6)
    }
    const validateConfirmPasswordField = (fieldName, fieldValue,passwordvalue) => { 
        errors[fieldName] = !fieldValue ? isEmpty(fieldName, fieldValue) : isTheSame(fieldName, fieldValue,passwordvalue)
    }
    const validatePhoneField = (fieldName, fieldValue) => { 
        errors[fieldName] = !fieldValue ? isEmpty(fieldName, fieldValue) :''
    }
    const validateCityField = (fieldName, fieldValue) => { 
        errors[fieldName] = !fieldValue ? isEmpty(fieldName, fieldValue) :''
    }
    
    const validateDaysField = (fieldName, fieldValue) => { 
        errors[fieldName] = !fieldValue ? isEmpty(fieldName, fieldValue) :''
    }
    const validateActivityField = (fieldName, fieldValue) => { 
        errors[fieldName] = !fieldValue ? isEmpty(fieldName, fieldValue) :''
    }
    const validateStoreNameField = (fieldName, fieldValue) => {
        errors[fieldName] = !fieldValue ? isEmpty(fieldName, fieldValue) : minLength(fieldName, fieldValue, 4)
    }
    const validateStoreDescriptionField = (fieldName, fieldValue) => {
        errors[fieldName] = !fieldValue ? isEmpty(fieldName, fieldValue) : minLength(fieldName, fieldValue, 6)
    }
    return { errors,
                validateEmailField,validatePasswordField,validateFirstNameField,validateLastNameField,
                validatePhoneField,validateCityField ,validateConfirmPasswordField,validateStoreNameField,
                validateStoreDescriptionField,validateDaysField,validateActivityField
            }
}